import React from "react";

const TopCoinUkPolicy = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
                <h4 className="title_text text-dark mb-3">TopCoin UK Ltd - Global Operating Policy</h4>
                <p className="text-dark fw-semibold opacity-50 mb-0">Effective Date: 6 September 2026</p>
                <p className="text-dark fw-semibold opacity-50 mb-0">Company Registration No.: 16483297 | info@topcoinuk.com</p>
                <p className="text-dark fw-semibold opacity-50 mb-3">Issued by: TopCoin UK Ltd</p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">1. Purpose and Scope</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  This Global Operating Policy sets out the general principles under which <strong>TopCoin UK Ltd ("TopCoin UK", "TCUK", "we", "us" or "our")</strong> intends to operate and develop the TopCoin UK platform internationally.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK is an <strong>advertising, promotional, customer loyalty and rewards platform</strong> designed to connect customers with participating companies, shops and retailers and provide qualifying customers with access to TopCoin and applicable rewards programmes.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  As TopCoin UK expands, services offered in each country or territory may differ according to local commercial arrangements and applicable laws and regulations.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  This policy provides an overall operating framework. It does not replace country-specific terms, customer terms, business agreements, privacy notices or other legally required documentation.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">2. TopCoin UK Operating Principles</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK is designed as a <strong>customer loyalty, rewards, advertising and promotional platform</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers may receive TopCoin through qualifying transactions, purchases, promotions or other activities specifically identified by TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin is used within the TopCoin UK ecosystem as a digital loyalty and reward unit.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin itself is not cash and has no standalone monetary or exchange value outside the TopCoin UK rewards system.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK does not represent TopCoin as a promise of investment profit, interest, dividends or financial return.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Any rewards available through TopCoin UK are governed by the applicable programme terms and qualifying conditions.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">3. The TopCoin UK Platform</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  The TopCoin UK platform may allow customers to:
                </p>
                <ul className="text-dark opacity-50 ms-4 mb-2" style={{ listStyleType: "disc" }}>
                  <li>Create and manage a TopCoin UK account;</li>
                  <li>Access their TopCoin Wallet;</li>
                  <li>Receive qualifying TopCoin;</li>
                  <li>Discover participating companies, shops and retailers;</li>
                  <li>Access qualifying offers and promotions;</li>
                  <li>Participate in applicable TopCoin UK rewards programmes; and</li>
                  <li>Where eligible, participate in the Captain TC Rewards Programme.</li>
                </ul>
                <p className="info_description text-dark opacity-50 mb-2">
                  Features may vary by country, customer, participating business or promotion.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK may introduce, modify or discontinue platform features in accordance with applicable terms and legal requirements.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">4. TopCoin Wallet</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  The <strong>TopCoin Wallet</strong> records qualifying TopCoin associated with a customer's TopCoin UK account.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin recorded within the wallet is used for the purposes specified by the applicable TopCoin UK loyalty and rewards programme.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Wallet records may be adjusted where a qualifying transaction is cancelled, refunded, reversed, found to be fraudulent or otherwise ceases to qualify under the applicable terms.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The TopCoin Wallet should not be described as a bank account or conventional cash account.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">5. Captain TC Rewards Programme</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where available, the <strong>Captain TC Rewards Programme</strong> operates as a promotional loyalty and rewards programme within the wider TopCoin UK platform.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Participation is governed by the separate <strong>Captain TC Rewards Programme Terms &amp; Conditions</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers must have a <strong>valid and active Captain TC Rewards Card</strong> to receive Captain TC Rewards TopCoin and become eligible for applicable Captain TC Rewards.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">Captain TC Rewards Cards may include:</p>
                <ul className="text-dark opacity-50 ms-4 mb-2" style={{ listStyleType: "disc" }}>
                  <li>Copper Captain TC Rewards Card</li>
                  <li>Silver Captain TC Rewards Card</li>
                  <li>Bronze Captain TC Rewards Card</li>
                  <li>Gold Captain TC Rewards Card</li>
                </ul>
                <p className="info_description text-dark opacity-50 mb-0">
                  Only <strong>one Captain TC Rewards Card may be active per customer at any one time</strong>, subject to the applicable programme terms.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">6. Captain TC Rewards Wallet</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Eligible customers with an active Captain TC Rewards Card should use their <strong>Captain TC Rewards Wallet</strong> within the TopCoin UK platform to view their active Captain TC Rewards Card, Captain TC Rewards TopCoin progress, progress towards applicable reward stages, qualifying rewards earned and other applicable Captain TC Rewards information.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The Captain TC Rewards Wallet is a programme-recording and display facility and is not itself a bank account, payment account or conventional cash balance.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">7. Captain TC Gold Cards</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where offered, <strong>Captain TC Gold Cards</strong> operate as a separate collectible element of the Captain TC Rewards Programme.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Captain TC Gold Cards are separate from the <strong>Gold Captain TC Rewards Card</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Qualifying Captain TC Gold Cards may be registered through the customer's <strong>Captain TC Gold Wallet</strong>, subject to the Captain TC Rewards Programme Terms &amp; Conditions.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers must have a valid and active Captain TC Rewards Card to qualify for Captain TC Gold Card rewards.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">8. Participating Companies, Shops and Retailers</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may work with participating companies, shops, retailers and other commercial partners in the United Kingdom and, where introduced, other countries.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Participating businesses may enter into commercial arrangements with TopCoin UK for services including advertising, promotional exposure, customer acquisition, loyalty and rewards campaigns, platform participation and other agreed marketing services.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  A participating business is not automatically required to discount its products or services unless this forms part of a specific agreed promotion.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The exact commercial arrangement will be governed by the applicable agreement between TopCoin UK and the participating business.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">9. Captain TC Rewards Card Distribution</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where applicable, participating companies, shops and retailers may provide Captain TC Rewards Cards to eligible customers in connection with qualifying products, purchases or promotions.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where a Captain TC Rewards Card is included with a qualifying purchase, it may be provided <strong>at no additional charge</strong> as part of the applicable Captain TC promotional rewards offer.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Not every business, product or purchase automatically qualifies.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The applicable promotion will determine the Rewards Card level and eligibility conditions.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">10. Separate Purchase of Captain TC Rewards Cards</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where TopCoin UK makes this option available, customers may be permitted to purchase a Captain TC Rewards Card separately through the TopCoin UK platform without purchasing a qualifying product from a participating business.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The applicable card level, price, benefits and conditions must be displayed to the customer before purchase.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  A Captain TC Rewards Card is a <strong>loyalty and rewards programme card</strong>. It is not itself used to pay participating companies, shops or retailers for products or services.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">11. Rewards Funding</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Rewards offered directly through the Captain TC Rewards Programme are funded or provided by <strong>TopCoin UK Ltd</strong>, except where an applicable promotion expressly states otherwise.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may fund these rewards as part of its advertising, promotional and customer-acquisition activities.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Participating businesses may pay TopCoin UK for advertising, promotional, loyalty or other agreed commercial services.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The fact that TopCoin UK receives commercial income from participating businesses does not by itself make those businesses responsible for providing Captain TC rewards to customers.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">12. Third-Party Rewards</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may use authorised third-party products or services to fulfil certain customer rewards.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  These may include gift cards, eGift cards, vouchers, retail products, promotional benefits or other reward products.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Third-party rewards may be subject to the issuing provider's own terms, availability, expiry dates and restrictions.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">13. International Expansion</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may expand into countries and territories outside the United Kingdom through subsidiaries, branches, licensees, affiliates, commercial partners or other legally appropriate structures.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The method used may vary by jurisdiction.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  International operations must comply with applicable local requirements, which may include consumer-protection law, advertising and marketing law, data-protection and privacy law, taxation, electronic commerce requirements, payment and financial-services regulation where applicable, promotional and prize regulations, and other applicable local laws.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  No TopCoin UK service should be launched in a new jurisdiction solely on the assumption that UK rules apply there.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">14. Country-Specific Terms</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may introduce separate terms, policies, disclosures or programme rules for individual countries or territories.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where local law requires different provisions, the relevant local terms may supplement or modify this Global Operating Policy for customers and businesses in that jurisdiction.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Mandatory local consumer rights will continue to apply where required by law.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">15. Customer Eligibility</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Unless different eligibility requirements are expressly introduced for a particular jurisdiction or service, TopCoin UK account-based services and the Captain TC Rewards Programme are intended for customers aged <strong>18 or over</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Additional eligibility conditions may apply to particular promotions, rewards, products or territories.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">16. Customer Protection and Transparency</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK aims to present qualifying offers, rewards and programme requirements clearly.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers should be informed of material conditions relevant to an offer before participating, including applicable eligibility requirements, reward conditions and any material restrictions.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK will not intentionally describe loyalty rewards as guaranteed investment returns, interest or financial profits.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">17. Data Protection and Privacy</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK processes personal information in accordance with its applicable <strong>Privacy Policy</strong> and relevant data-protection requirements.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where TopCoin UK expands internationally, additional privacy notices or safeguards may be introduced where required by local law.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers should be provided with appropriate information concerning how their personal information is collected, used, shared, protected and retained.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">18. Fraud Prevention and Programme Abuse</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may investigate, restrict, suspend or terminate participation where there are reasonable grounds to suspect fraud, false or manipulated transactions, artificial generation of TopCoin or rewards, multiple accounts created to circumvent programme rules, unauthorised registration or duplication of Captain TC cards, manipulation of reward claims, abuse of participating-business promotions or other material misuse of the TopCoin UK platform.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where appropriate, TopCoin UK may reverse TopCoin, Captain TC Rewards TopCoin or rewards associated with transactions that are fraudulent, cancelled, refunded, reversed or otherwise ineligible.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Any action taken will remain subject to applicable law and contractual rights.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">19. Global Brand and Intellectual Property</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  The <strong>TopCoin UK, Captain TC</strong>, related logos, designs, programme materials and other intellectual property must be used in accordance with TopCoin UK's authorisation and applicable agreements.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  International partners, licensees and participating businesses must not materially alter TopCoin UK or Captain TC branding or make unauthorised representations about the programme.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Localisation may be permitted where appropriate, but material changes to brand positioning or programme claims should be approved by TopCoin UK.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">20. Advertising and Promotional Standards</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Advertising and promotional material relating to TopCoin UK or Captain TC must be clear, accurate and capable of substantiation where required.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Partners should not describe TopCoin or Captain TC rewards using misleading financial terminology or make unsupported claims concerning guaranteed earnings, investment performance or financial returns.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The wording <strong>"TopCoin UK - Earn While You Spend"</strong>, or another wording approved by TopCoin UK for a particular market, may be used subject to applicable advertising and consumer-protection requirements.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">21. Commercial Partners and Affiliates</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may operate through affiliate networks, commercial partnerships, participating retailers and other marketing arrangements.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may receive affiliate commissions, advertising fees, participation fees or other commercial income arising from these relationships.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Commercial arrangements should be documented under appropriate agreements and disclosed to customers where disclosure is legally required.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">22. Regulatory Compliance</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK will seek to operate its services in accordance with applicable laws and regulations in each jurisdiction where those services are offered.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The legal classification of a particular service depends on its <strong>actual structure and operation</strong>, not simply the terminology used to describe it.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Accordingly, new payment functionality, stored-value functionality, transferable value, cash-conversion mechanisms or materially different financial features should undergo appropriate legal and regulatory review before introduction.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">23. Changes to the Global Operating Model</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may develop or modify its international operating model as the business expands.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Changes may include new countries, participating businesses, rewards, programme structures, technologies or commercial partnerships.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where changes materially affect customer rights or obligations, TopCoin UK will provide information or notice as required by applicable law and the relevant terms.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">24. Relationship with Other TopCoin UK Documents</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  This Global Operating Policy provides a high-level framework and should be read alongside the applicable:
                </p>
                <ul className="text-dark opacity-50 ms-4 mb-2" style={{ listStyleType: "disc" }}>
                  <li><strong>TopCoin UK General Terms &amp; Conditions</strong></li>
                  <li><strong>Captain TC Rewards Programme Terms &amp; Conditions</strong></li>
                  <li><strong>TopCoin UK Privacy Policy</strong></li>
                  <li><strong>TopCoin UK Cookie Policy</strong></li>
                  <li><strong>TopCoin UK Website Disclaimer</strong></li>
                </ul>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where a specific customer transaction or programme is governed by separate terms, those specific terms will apply to that transaction or programme.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">25. Contact</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Questions regarding this Global Operating Policy may be directed to:
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  <strong>TopCoin UK Ltd</strong><br />
                  Company Registration No.: 16483297<br />
                  Email: <strong>info@topcoinuk.com</strong>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopCoinUkPolicy;
